import { Collapse as AntCollapse } from 'antd';
import classNames from 'classnames';
import './style/index';
import { jsx as _jsx } from "react/jsx-runtime";
const Collapse = _ref => {
  let {
    className,
    children,
    prefixClass = 'zen-design',
    ...restProps
  } = _ref;
  const baseClassName = "".concat(prefixClass, "-collapse");
  return /*#__PURE__*/_jsx("div", {
    className: classNames(className, "".concat(baseClassName)),
    children: /*#__PURE__*/_jsx(AntCollapse, {
      ...restProps,
      children: children
    })
  });
};
Collapse.Panel = AntCollapse.Panel;
export default Collapse;